import Reveal from "@/components/base/Reveal";
import { sobreValues } from "@/mocks/sobre";

export default function SobreValues() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-700">
              <i className="ri-heart-3-line" aria-hidden="true"></i>
              Nossos valores
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              O que guia o nosso trabalho.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Princípios que sustentam cada projeto e cada atendimento realizado pela NXHOST.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {sobreValues.map((value, index) => (
            <Reveal key={value.title} delay={index * 60} className="h-full">
              <article className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-accent-300 hover:bg-background-100/60">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100/70 text-accent-700">
                  <i className={`${value.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {value.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {value.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}